
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, Modal, Image } from 'semantic-ui-react'
import { getHasError, getError } from '../selectors'
import { setError } from '../actions'

class ErrorMessage extends React.Component {
	state = { open: this.props.hasError }

	close = () => {
		this.setState({ open: false })
		this.props.clearError()
	}

	componentWillReceiveProps(nextProp) {
		this.setState({ open: nextProp.hasError })
	}

	render() {
		return (
			<Modal open={this.state.open} onClose={this.close} size="small">
				<Modal.Content style={{ height: 'auto' }}>
					<div className="errormessage">
						<div className="contenterror">
							<div className="content-text">
								<div className="close" onClick={this.close}>
									<Image src='/assets/images/icon-cross-red.png' />
								</div>
								<h2>Something went wrong.</h2>
								{
									this.props.hasError
										&& this.props.error != null
										&& this.props.error.code !== undefined
										&& this.props.error.message !== undefined ?
										<p>{this.props.error.message}</p>
										: <p>Something went wrong.</p>
								}
							</div>
						</div>

					</div>
				</Modal.Content>
			</Modal>
		)
	}
}

export default compose(
	connect(
		(state, props) => ({
			hasError: getHasError(state),
			error: getError(state),
		}),
		(dispatch) => ({
			clearError() {
				dispatch(setError(false))
			},
		})
	)
)(ErrorMessage)


// WEBPACK FOOTER //
// ./src/features/ui/components/ErrorMessageDialog.js